export default {
    description: "Beschrijving",
    orderingNote: "Bestelnotitie"
}